module.exports = __webpack_public_path__ + "img/company2_1.6c3d9f05.png";